export const SUMMARY_VIEW = {
  grid: 'grid',
  table: 'table'
};

export const GRID_CLAIMS_PER_PAGE = 6;
export const TABLE_CLAIMS_PER_PAGE = 12;